import { MUIMarkdown } from '@modules/common/components/MUIMarkdown';
import { MarkdownTypewriter } from '@modules/common/components/MUIMarkdown/MarkdownTypewriter';
import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';
import { CustomMarkdownComponents } from '@modules/oracle/types';
import { useMemo } from 'react';
import { LabelName } from './LabelName';
import { OracleInsightProofIconButton } from './OracleInsightProofIconButton';
import { OracleQuantifyChartWrapper } from './OracleQuantifyChartWrapper';

interface OracleConversationMarkdownProps {
  promptID: string;
  markdown: string;
  isLoading?: boolean;
  shouldSkipTypingAnimation?: boolean;
  stepID?: string;
}

export function OracleConversationMarkdown({
  promptID,
  markdown,
  isLoading,
  stepID,
  shouldSkipTypingAnimation,
}: OracleConversationMarkdownProps) {
  const sessionID = useOracleSearchStore(({ data }) => data.sessionID);

  const components: CustomMarkdownComponents = useMemo(() => {
    return {
      reason: LabelName,
      tk: LabelName,
      quantify: (props) => {
        return <OracleQuantifyChartWrapper {...props} promptID={promptID} />;
      },
      'feedback-count': (props) => {
        return sessionID ? (
          <OracleInsightProofIconButton
            {...props}
            promptID={promptID}
            sessionID={sessionID}
          />
        ) : null;
      },
    };
  }, [promptID, sessionID]);

  if (shouldSkipTypingAnimation) {
    return <MUIMarkdown markdown={markdown} components={components} />;
  }

  return (
    <MarkdownTypewriter
      markdown={markdown}
      isLoading={isLoading}
      components={components}
    />
  );
}
